<span appTitle class="font-weight-500" [translate]="title"></span>
